import PremiseListView from "features/ManagePremises/components/PremiseListView";
import AppConstants from "general/constants/AppConstants";
import Global from "general/utils/Global";
import useRouter from "hooks/useRouter";
import { useMemo } from "react";
import { useSelector } from "react-redux";

function PremiseListScreen() {
    const { query } = useRouter();
    const agencyId = query?.landownerId;
    const { user } = useSelector((state) => state.auth);

    const isAdmin = useMemo(() =>
        user?.role === AppConstants.userRole.admin ||
        user?.role === AppConstants.userRole.operator,
        [user?.role]
    );

    let premiseListFilter = useMemo(() => {
        Global.g_filterPremisesList = {
            ...Global.g_filterPremisesList,
            landlordId: !isAdmin && user?.agency?.agencyId
                ? user.agency.agencyId
                : ''
        }

        return Global.g_filterPremisesList;
    }, [isAdmin, user?.agency?.agencyId]);

    return (
        <div className="m-4">
            <PremiseListView
                premiseListFilter={premiseListFilter}
                agencyId={agencyId}
            />
        </div>
    );
}

export default PremiseListScreen;